"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const Services_1 = __importDefault(require("../Services"));
const Loader_1 = require("../Utils/Loader");
const Delay_1 = require("../Utils/Delay");
const EmptyCart_1 = __importDefault(require("../templates/Cart/EmptyCart"));
const UrlGenerator_1 = require("../Utils/UrlGenerator/UrlGenerator");
const ToasterNotification_1 = __importDefault(require("../../../../global/js/Utils/ToasterNotification"));
const axios_1 = __importDefault(require("axios"));
class Cart {
    main() {
        this.addActionController();
        this.removeActionController();
        this.index();
    }
    index() {
        const $this = this;
        this.increment();
        this.decrement();
        $(document).on('click', '.js-checkout-btn-remove', function (e) {
            e.preventDefault();
            const $this_elem = $(this);
            const $parent = $this_elem.closest('.js-cart-item');
            Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-light-danger',
                    cancelButton: 'btn btn-secondary'
                }
            }).fire({
                text: 'از حذف این محصول مطمئنی؟',
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'بزار بمونه',
                confirmButtonText: "<i class='fad fa-trash-alt'></i> حذفش کن",
                allowOutsideClick: false,
            }).then((res) => {
                if (res.isConfirmed) {
                    Cart.loader();
                    const $response = $this.remove($this_elem.data('item-id'));
                    $response.then(({ data }) => {
                        data = data.data;
                        (0, Delay_1.delay)().time(1).handler(() => {
                            $parent.fadeOut('slow', function () {
                                (0, Delay_1.delay)()
                                    .time(2)
                                    .handler(() => {
                                    $parent.remove();
                                    Cart.reloadCheckoutSummery(data.summary);
                                }).fire();
                                ToasterNotification_1.default.warning(3, 'از سبد خرید حذف شد!', false);
                                Cart.loader(false);
                            });
                        }).fire();
                    }).catch((error) => {
                        if (error.status === 409) {
                            (0, Delay_1.delay)().time(500).handler(() => {
                                ToasterNotification_1.default.error(3, 'مشکلی بوجود آمده لطفا صفحه را مجدد بارگذاری کنید و سپس تلاش نمایید.');
                            }).fire();
                        }
                        if (error.status === 403) {
                            Services_1.default.Request.reload();
                        }
                        Cart.loader(false);
                    });
                }
            });
        });
    }
    static loader(show = true) {
        if (!show) {
            (0, Loader_1.loader)().unblockPage();
            return;
        }
        (0, Loader_1.loader)().blockPage({
            state: 'danger',
            message: 'کمی صبر کنید...',
            opacity: 0.5,
        });
    }
    addActionController() {
        const $this = this;
        $(document).on('click', '.js-btn-add-to-cart', function (e) {
            e.preventDefault();
            const $this_elem = $(this);
            let $parent;
            const $response = $this.add($this_elem.data('href'));
            (0, Loader_1.loader)().blockPage({
                state: 'danger',
                message: 'کمی صبر کنید...',
                opacity: 0.5,
            });
            $response.then((response) => {
                if (($this_elem.closest('.product-info')).length > 0) {
                    $this_elem.closest('.product-info-actions').fadeOut('slow', function () {
                        const $cart_url = (0, UrlGenerator_1.url)('Cart.indexCart').make().getFullUrl();
                        $this_elem.replaceWith(`
                            <div class="js-has-cart-item">
                                <button type="button" class="btn btn-light-success btn-hover-light-success">
                                    <i class="fad fa-check-circle"></i>
                                    به سبد اضافه شد
                                </button>
                                <button class="btn btn-light-danger btn-sm btn-icon js-cart-btn-remove-item mr-3" 
                                    data-toggle="tooltip" 
                                    data-placement="bottom" 
                                    data-theme="dark" title="حذف از سبد">
                                    <i class="fad fa-trash-alt fs-6"></i>
                                </button>
                                <a href="${$cart_url}" class="btn btn-light-primary btn-sm btn-icon mr-3" 
                                    data-toggle="tooltip" data-placement="bottom" 
                                    data-theme="dark" title="مشاهده سبد">
                                    <i class="fad fa-shopping-cart fs-6"></i>
                                </a>
                            </div>
                        `);
                        $(this).fadeIn('slow', () => {
                            ToasterNotification_1.default.success(3, 'به سبد خرید اضافه شد!');
                            (0, Loader_1.loader)().unblockPage();
                            Services_1.default.initTooltips();
                        });
                    });
                }
                else {
                    (0, Delay_1.delay)().time(1).handler(() => {
                        $this_elem.closest('.product-item-actions').fadeOut('fast', function () {
                            let $item_id = lodash_1.default.toNumber($(this).data('item'));
                            if (isNaN($item_id)) {
                                ToasterNotification_1.default.error(3, 'مشکلی به وجود آمده است.');
                                (0, Delay_1.delay)().time(400).handler(() => {
                                    Services_1.default.Request.reload();
                                }).fire();
                                return;
                            }
                            const $remove_cart_url = (0, UrlGenerator_1.url)('Cart.removeFromCart', $item_id).make().getFullUrl();
                            $this_elem.replaceWith(`
                                <button
                                        data-href="${$remove_cart_url}"
                                        class="btn btn-sm w-100 js-cart-btn-remove-item"><i class="fad fa-trash-alt"></i> حذف از سبد خرید</button>
                            `);
                            $(this).fadeIn('fast', () => {
                                ToasterNotification_1.default.success(3, 'به سبد خرید اضافه شد!');
                                (0, Loader_1.loader)().unblockPage();
                                Services_1.default.initTooltips();
                                Swal.fire({
                                    text: 'به سبد خرید اضافه شد!',
                                    icon: 'success',
                                    showCancelButton: true,
                                    cancelButtonText: 'ادامه خرید',
                                    confirmButtonText: "<i class='fad fa-shopping-cart'></i> رفتن به سبد خرید",
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        Services_1.default.Request.redirect('/checkout/cart');
                                    }
                                });
                            });
                        });
                    }).fire();
                }
            }).catch((error) => {
                if (error.status === 409) {
                    (0, Delay_1.delay)().time(500).handler(() => {
                        ToasterNotification_1.default.error(3, 'مشکلی بوجود آمده لطفا صفحه را مجدد بارگذاری کنید و سپس تلاش نمایید.');
                    }).fire();
                }
                if (error.status === 403) {
                    Services_1.default.Request.reload();
                }
                Cart.loader(false);
            }).finally(() => {
                $(".tooltip").tooltip("hide");
            });
        });
    }
    removeActionController() {
        const $this = this;
        $(document).on('click', '.js-cart-btn-remove-item', function (e) {
            var _a;
            e.preventDefault();
            const $this_elem = $(this);
            let $parent;
            let $item_id = $this_elem.closest('.product-info-actions').data('cart');
            const $response = $this.remove((_a = $this_elem.data('href')) !== null && _a !== void 0 ? _a : $item_id);
            Cart.loader();
            $response.then((response) => {
                (0, Delay_1.delay)().time(1).handler(() => {
                    if (($this_elem.closest('.product-info')).length > 0) {
                        if (lodash_1.default.isUndefined($item_id)) {
                            Services_1.default.Request.reload();
                        }
                        $this_elem.closest('.product-info-actions').fadeOut('fast', function () {
                            const $add_cart_url = (0, UrlGenerator_1.url)('Cart.addToCart', $item_id).make().getFullUrl();
                            $this_elem.closest('.js-has-cart-item').replaceWith(`
                                <a href="javascript:;" data-href="${$add_cart_url}" class="btn btn-danger border-radius-xl fs-6 js-btn-add-to-cart">
                                    <i class="fad fa-cart-circle-plus"></i>
                                    افزودن به سبد خرید
                                </a>
                            `);
                            $(this).fadeIn('fast', () => {
                                ToasterNotification_1.default.warning(3, 'از سبد خرید حذف شد!');
                                Cart.loader(false);
                                Services_1.default.initTooltips();
                            });
                        });
                    }
                    else {
                        $this_elem.closest('.product-item-actions').fadeOut('fast', function () {
                            $item_id = lodash_1.default.toNumber($(this).data('item'));
                            if (isNaN($item_id)) {
                                ToasterNotification_1.default.error(3, 'مشکلی به وجود آمده است.');
                                (0, Delay_1.delay)().time(500).handler(() => {
                                    Services_1.default.Request.reload();
                                }).fire();
                                return;
                            }
                            const $add_cart_url = (0, UrlGenerator_1.url)('Cart.addToCart', $item_id).make().getFullUrl();
                            const $remove_cart_url = (0, UrlGenerator_1.url)('Cart.removeFromCart', $item_id).make().getFullUrl();
                            $this_elem.replaceWith(`
                                    <button
                                            data-href="${$add_cart_url}"
                                            data-remove-cart="${$remove_cart_url}"
                                            class="btn btn-sm w-100 js-btn-add-to-cart"><i class="fad fa-cart-plus"></i> افزودن به سبد خرید</button>
                                `);
                            $(this).fadeIn('fast', () => {
                                ToasterNotification_1.default.warning(3, 'از سبد خرید حذف شد!');
                                Cart.loader(false);
                                Services_1.default.initTooltips();
                            });
                        });
                    }
                }).fire();
            }).catch((error) => {
                if (error.status === 409) {
                    (0, Delay_1.delay)().time(500).handler(() => {
                        ToasterNotification_1.default.error(3, 'مشکلی بوجود آمده لطفا صفحه را مجدد بارگذاری کنید و سپس تلاش نمایید.');
                    }).fire();
                }
                if (error.status === 403) {
                    Services_1.default.Request.reload();
                }
                Cart.loader(false);
            }).finally(() => {
                $(".tooltip").tooltip("hide");
            });
        });
    }
    add(item) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                (0, axios_1.default)({
                    url: isNaN(lodash_1.default.toNumber(item)) ? item : (0, UrlGenerator_1.url)('Cart.addToCart', item).make().getFullUrl(),
                    method: 'POST',
                }).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error.response);
                });
            });
        });
    }
    update(item, event) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve, reject) => {
                (0, axios_1.default)({
                    url: (0, UrlGenerator_1.url)('Cart.updateCart', item).make().getFullUrl(),
                    method: 'PUT',
                    data: {
                        event: event,
                    },
                }).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error.response);
                });
            });
        });
    }
    remove(item) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = isNaN(lodash_1.default.toNumber(item)) ? item : (0, UrlGenerator_1.url)('Cart.removeFromCart', item).make().getFullUrl();
            return yield new Promise((resolve, reject) => {
                (0, axios_1.default)({
                    url: uri,
                    method: 'DELETE',
                }).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error.response);
                });
            });
        });
    }
    static revisionQuantityButtons(parent_elem, item) {
        const item_id = lodash_1.default.toNumber(lodash_1.default.get(item, 'id'));
        const quantity = lodash_1.default.toNumber(lodash_1.default.get(item, 'quantity', 1));
        const order_is_limited = lodash_1.default.get(item, 'order_is_limited', false);
        if (quantity === 1) {
            parent_elem.find('.decrement').replaceWith(`<span data-item-id="${item_id}" class="js-checkout-btn-remove"><i class="far fa-trash-alt"></i></span>`);
        }
        else {
            parent_elem.find('.js-checkout-btn-remove').replaceWith(`<span class="decrement"><i class="fas fa-minus"></i></span>`);
        }
        if (order_is_limited) {
            parent_elem.find('.increment').attr('disabled', '').addClass('disabled');
        }
        else {
            parent_elem.find('.increment').removeAttr('disabled').removeClass('disabled');
        }
    }
    static revisionItemProperties(parent_elem, item) {
        parent_elem.find('.quantity').html(lodash_1.default.get(item, 'quantity'));
        parent_elem.closest('.js-cart-item').find('.js-total-amount').html(lodash_1.default.get(item, 'price.with_condition.sum_formatted', 0));
    }
    decrement() {
        const $this = this;
        $(document).on('click', '.decrement', function () {
            const $parent = $(this).closest('.number-input');
            const $id = $parent.data('item-id');
            Cart.loader();
            if (!lodash_1.default.isUndefined($id)) {
                const $response = $this.update($id, 'decrement');
                $response.then(({ data }) => {
                    data = data.data;
                    Cart.revisionItemProperties($parent, data.item);
                    Cart.reloadCheckoutSummery(data.summary);
                    Cart.revisionQuantityButtons($parent, data.item);
                    Cart.loader(false);
                }).catch((error) => {
                    if (error.status === 409) {
                        ToasterNotification_1.default.error(3, 'مشکلی بوجود آمده لطفا صفحه را مجدد بارگذاری کنید و سپس تلاش نمایید.');
                    }
                    if (error.status === 403) {
                        Services_1.default.Request.reload();
                    }
                    Cart.loader(false);
                }).finally(() => {
                    $(".tooltip").tooltip("hide");
                });
            }
        });
    }
    increment() {
        const $this = this;
        $(document).on('click', '.increment:not([disabled], .disabled)', function () {
            const $parent = $(this).closest('.number-input');
            const $id = $parent.data('item-id');
            if (!lodash_1.default.isUndefined($id)) {
                Cart.loader();
                const $response = $this.update($id, 'increment');
                $response.then(({ data }) => {
                    data = data.data;
                    Cart.reloadCheckoutSummery(data.summary);
                    Cart.revisionItemProperties($parent, data.item);
                    Cart.revisionQuantityButtons($parent, data.item);
                    Cart.loader(false);
                }).catch((error) => {
                    if (error.status === 409) {
                        ToasterNotification_1.default.error(3, 'مشکلی بوجود آمده لطفا صفحه را مجدد بارگذاری کنید و سپس تلاش نمایید.');
                        Cart.loader(false);
                    }
                    if (error.status === 403) {
                        Services_1.default.Request.reload();
                    }
                }).finally(() => {
                    $(".tooltip").tooltip("hide");
                });
            }
        });
    }
    static reloadCheckoutSummery(summery) {
        const $wrapper = $(document).find('.js-checkout-wrapper');
        let $wrapper_summary_price_list;
        if (lodash_1.default.get(summery, 'properties.is_empty')) {
            $wrapper.fadeOut('fast', function () {
                $wrapper.html(EmptyCart_1.default).fadeIn('fast', function () {
                    ToasterNotification_1.default.success(3, 'سبد خرید شما خالی شد!');
                });
            });
            return;
        }
        const $summery_wrapper = $wrapper.find('.js-checkout-summary-wrapper');
        $wrapper.find('.js-count-cart-products').text(lodash_1.default.get(summery, 'number_products'));
        $wrapper.find('.js-number-items').text(lodash_1.default.get(summery, 'number_items'));
        if (lodash_1.default.get(summery, 'properties.has_conditions')) {
            if (($wrapper_summary_price_list = $summery_wrapper.find('.js-checkout-summary-price-list')).find('.js-checkout-summary-discount').length === 0) {
                $wrapper_summary_price_list.fadeOut('fast', function () {
                    $wrapper_summary_price_list
                        .find('.js-checkout-actions')
                        .before(`<div class="purchase-profit d-flex justify-content-between align-items-center mb-3 px-3 pt-1 js-checkout-summary-discount">
                                    <p class="fs-7 fw-bold text-danger">
                                        سود شما از خرید (<span class="js-checkout-profit-percentage">0</span>)
                                    </p>
                                    <p class="fs-6 fw-bold text-danger js-checkout-profit" style="--currency-symbol-color: var(--bs-red)"></p>
                                </div>`);
                    $(this).fadeIn('fast');
                });
            }
            $summery_wrapper.find('.js-checkout-summary-price-list .js-checkout-summary-discount .js-checkout-profit').html(lodash_1.default.get(summery, 'profit_buy_formatted'));
            $summery_wrapper.find('.js-checkout-summary-price-list .js-checkout-summary-discount .js-checkout-profit-percentage').html(lodash_1.default.get(summery, 'profit_buy_percentage') + '٪');
        }
        $summery_wrapper.find('.js-checkout-summary-price-list .js-checkout-total-amount').html(lodash_1.default.get(summery, 'subtotal_without_conditions_formatted'));
        $summery_wrapper.find('.js-total-amount-payable').html(lodash_1.default.get(summery, 'total_formatted'));
    }
}
exports.default = Cart;
